<div class="row">
    <div class="col-lg-3">
        Selecciona Grupo:
        <select class="form-control" [(ngModel)]="currentGrupo" #grupoSelect>
            <option value="">Seleccione Grupo</option>
            <option *ngFor = "let grupo of grupos" [value]="grupo.id">{{grupo.nombre}}</option>
        </select>
        <br>
    </div>

    <div class="col-3">
        <br>
        <button class="btn btn-success">Agregar</button>
    </div>
</div>

<div class="row">
    <div class="col-3" *ngFor="let grupoS of gruposSeleccionados">
        {{grupoS}}
    </div>
    <div class="col-3"></div>
    <div class="col-3"></div>
</div>
